




import { Component, Vue } from "vue-property-decorator";
import { corners } from "../../graphics/hex";

@Component
export default class SpaceHex extends Vue {
  get hexCorners() {
    return corners();
  }
}
